import { ArdoqId } from '@ardoq/api-types';
import {
  type ComponentTypeInfo,
  componentUrlFieldValues,
  getUrlFieldsByComponentType,
  type ReferenceTypeInfo,
  getUrlFieldsByReferenceType,
  referenceUrlFieldValues,
  GraphInterface,
  LabelsInterface,
} from '@ardoq/graph';

interface UrlFieldValuesArgs {
  componentTypes: ComponentTypeInfo[];
  referenceTypes: ReferenceTypeInfo[];
  componentIds: ArdoqId[];
  referenceIds: ArdoqId[];
  viewInterface: GraphInterface & LabelsInterface;
}
const urlFieldValues = ({
  componentTypes,
  referenceTypes,
  componentIds,
  referenceIds,
  viewInterface,
}: UrlFieldValuesArgs) => {
  const urlFieldsByComponentType = getUrlFieldsByComponentType(
    viewInterface,
    componentTypes
  );
  const urlFieldsByReferenceType = getUrlFieldsByReferenceType(
    viewInterface,
    referenceTypes
  );
  return {
    urlFieldValuesByComponentId: componentUrlFieldValues(
      viewInterface,
      componentIds,
      urlFieldsByComponentType
    ),
    urlFieldValuesByReferenceId: referenceUrlFieldValues(
      viewInterface,
      referenceIds,
      urlFieldsByReferenceType
    ),
  };
};

export { urlFieldValues };
